// import * as CryptoJS from "crypto-js";
// import JsBarcode from "jsbarcode";
import { DateRange } from "react-day-picker";

// const AES = require("crypto-js/aes");
// const enc = require("crypto-js/enc-utf8")
const deepCopyFunction = (inObject: any) => {
  let outObject: any, value: any, key: any
  if (typeof inObject !== "object" || inObject === null) {
    return inObject // Return the value if inObject is not an object
  }
  // Create an array or object to hold the values
  outObject = Array.isArray(inObject) ? [] : {}
  for (key in inObject) {
    value = inObject[key]
    // Recursively (deep) copy for nested objects, including arrays
    outObject[key] = (typeof value === "object" && value !== null) ? deepCopyFunction(value) : value
  }
  return outObject
}

// const encryptValue = (value: any, secretKey: any) => {
//   return AES.encrypt(value, secretKey).toString();
// }

// const decryptValue = (cipherValue: any, secretKey: any) => {
//   return AES.decrypt(cipherValue, secretKey).toString(enc);
// }

const encryptValue = (value: any, secretKey: any) => {

  const CryptoJS = require("crypto-js");
  return CryptoJS.AES.encrypt(value, secretKey).toString();
}



const decryptValue = (cipherValue: any, secretKey: any) => {
  const CryptoJS = require("crypto-js");
  return CryptoJS.AES.decrypt(cipherValue, secretKey).toString(
    CryptoJS.enc.Utf8
  );
}

const isArrayNotEmpty = (array: any) => {
  if (array && array.length > 0) {
    return true;
  } else {
    return false;
  }
}

const isArrayEmpty = (array: any) => {
  if (array && array.length > 0) {
    return false;
  } else {
    return true;
  }
}

const toMb = (bytes: any) => {
  let mb = bytes / 1024 / 1024
  return Math.round(mb);
}

// The single round-off rule for a bill's grand total, shared by Create/Edit
// Bill, View Billing and the printed receipt so all three always agree:
// round the pre-roundoff amount to the nearest rupee (>=50 paise rounds up,
// otherwise down), then subtract the user-entered overall discount
// ("roundOff"). Returns a fixed-2-decimal string, matching how every screen
// already formats totals.
const computeRoundedTotal = (rawAmount: any, overallDiscount: any) => {
  const amount = Number(rawAmount) || 0;
  const discount = Number(overallDiscount) || 0;
  const decimalStr = amount.toFixed(2).toString().split('.')[1];
  const rounded = Number(decimalStr) >= 50 ? Math.ceil(amount) : Math.floor(amount);
  return parseFloat(String(rounded - discount)).toFixed(2);
}

// A product can be added as more than one billing line (e.g. same barcode at
// two different discounts) — invoice/receipt views are read-only, so those
// lines are merged back into one row per productId here, summing quantity
// and taking a gross-weighted average discount% so the merged row's numbers
// still foot to the same total.
const mergeDuplicateProductLines = (items: any[]) => {
  const merged = new Map<string, any>();
  (items || []).forEach((item: any) => {
    const key = item?.productId;
    const qty = Number(item?.itemsCount) || 0;
    const mrp = Number(item?.mrp) || 0;
    const gross = mrp * qty;
    const discountAmount = gross * ((Number(item?.discountPercentage) || 0) / 100);
    const existing = merged.get(key);
    if (existing) {
      existing.itemsCount += qty;
      existing.grossTotal += gross;
      existing.discountAmount += discountAmount;
    } else {
      merged.set(key, { ...item, itemsCount: qty, grossTotal: gross, discountAmount });
    }
  });
  return Array.from(merged.values()).map((m: any) => ({
    ...m,
    discountPercentage: m.grossTotal > 0 ? (m.discountAmount / m.grossTotal) * 100 : 0,
  }));
}

// "Nil" is the walk-in/no-phone placeholder used throughout Billing/Customers —
// exempt from length validation entirely. Any other value must be exactly 10
// digits. Mobile numbers are handled as strings everywhere here (never
// parsed to a number), so this checks .length rather than a numeric range.
const isValidMobileNumber = (value: any): boolean => {
  const sanitized = String(value ?? "").trim();
  if (sanitized.toLowerCase() === "nil") return true;
  // Backend-generated placeholder for a named customer with no real phone on
  // file (apparel-api's addLeadingZerosAndAppend: `${id}_${zeros}`, e.g.
  // "7652_00000") — never user-typed, so it's exempt the same way "Nil" is.
  // Otherwise picking such a customer from suggestions would block Save.
  if (/^\d+_\d*$/.test(sanitized)) return true;
  return /^\d+$/.test(sanitized) && sanitized.length === 10;
}

// Indian Financial Year runs Apr 1 - Mar 31. Mirrors the same boundary math
// as apparel-api's CustomerCreditService/VendorDebtService.resolveFinancialYearRange,
// used by the Customer Credit / Vendor Debt dashboards to default (and offer
// quick "This FY"/"Last FY" shortcuts for) their date-range filter.
// offsetYears=0 -> current FY (Apr 1 -> today); offsetYears=-1 -> previous FY
// (Apr 1 -> Mar 31, fully closed).
const getFinancialYearRange = (offsetYears: number = 0): DateRange => {
  const today = new Date();
  const currentFyStartYear = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
  const fyStartYear = currentFyStartYear + offsetYears;
  const from = new Date(fyStartYear, 3, 1);
  const to = offsetYears >= 0 ? today : new Date(fyStartYear + 1, 2, 31);
  return { from, to };
}

export {
  deepCopyFunction,
  encryptValue,
  decryptValue,
  isArrayNotEmpty,
  isArrayEmpty,
  toMb,
  mergeDuplicateProductLines,
  computeRoundedTotal,
  isValidMobileNumber,
  getFinancialYearRange
}